import Page from "@/components/Page"
import Spinner from "@/components/Spinner"
import { useSelfQuery } from "@/data/queries"
import { ROUTES, withQuery } from "@/routes"
import FindBarcodeStep from "@/screens/onboarding/steps/FindBarcodeStep"
import ScanDeviceStep from "@/screens/onboarding/steps/ScanDeviceStep"
import ShippingStep from "@/screens/onboarding/steps/ShippingStep"
import { Navigate, useNavigate, useSearchParams } from "react-router"

const LINK_DEVICE_STEPS = ["shipping", "find-barcode", "scan-device"] as const
type LinkDeviceStep = (typeof LINK_DEVICE_STEPS)[number]

const isValidStep = (value: string | null): value is LinkDeviceStep =>
  LINK_DEVICE_STEPS.includes(value as LinkDeviceStep)

const stepUrl = (step: LinkDeviceStep) => withQuery(ROUTES.LINK_DEVICE, { step })

const LinkDevicePage = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const step = searchParams.get("step")
  const { data: self } = useSelfQuery()

  if (!isValidStep(step)) {
    return <Navigate to={stepUrl("shipping")} replace />
  }

  if (!self) {
    return (
      <Page showAppbar={false}>
        <div className="flex justify-center py-12">
          <Spinner />
        </div>
      </Page>
    )
  }

  const goToStep = (next: LinkDeviceStep) => setSearchParams({ step: next }, { replace: true })
  const goToSettings = () => navigate(ROUTES.SETTINGS, { replace: true })

  switch (step) {
    case "shipping":
      return <ShippingStep onNext={() => goToStep("find-barcode")} onBack={goToSettings} />
    case "find-barcode":
      return (
        <FindBarcodeStep
          onNext={() => goToStep("scan-device")}
          onBack={() => goToStep("shipping")}
        />
      )
    case "scan-device":
      return (
        <ScanDeviceStep
          patientId={self.id}
          onLinked={goToSettings}
          onCheckAddress={() => goToStep("shipping")}
          onBack={() => goToStep("find-barcode")}
        />
      )
  }
}

export default LinkDevicePage
